<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11" fill="#F59E0B" />
    <path
      d="M16.5 13.2782H10.9424V6.75"
      stroke="white"
      stroke-width="1.91711"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
